import React from 'react'
import Field from  'components/controls/field'
import { onChange } from 'shared/helpers/functional'
import { pathOr } from 'ramda'

const valueOf = pathOr('', ['answer', 'answerComments', '0', 'comment'])

const Comment = ({question, setComment, setCommentPastedText, setCommentAnwerStartTime, translate, placeholderText, commentText, setCommentText, t}) => (
  <div className="question-comment">
    <div className="input-label-text"
      dangerouslySetInnerHTML={{
        __html: t('question.comments') //null,//question.commentText || translate('question.comments'),
      }}
    />
    <Field
      type="textarea"
      name="open-ended"
      value={commentText}
      onChange={(val) => setCommentText(val.target.value)}
      // onPaste={function (e) { setCommentPastedText(
      //   e.clipboardData.getData('Text'))
      // }}
      // onFocus={function () { setCommentAnwerStartTime()
      // }}
      placeholder = {placeholderText}
    />
  </div>
)

export default Comment
